import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["name", "control", "rules", "defaultValue", "containerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { JoveButton } from '@jove-frontend/mui';
import { LoadingMask } from '@jove-frontend/uikit';
import { ImageOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { useDropzone } from 'react-dropzone';
import { useController } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var JoveLogoUpload = function JoveLogoUpload(props) {
  var loading = props.loading,
      chooseFile = props.chooseFile,
      src = props.src,
      disabled = props.disabled,
      className = props.className,
      _props$buttonText = props.buttonText,
      buttonText = _props$buttonText === void 0 ? 'Upload logo' : _props$buttonText,
      _props$descList = props.descList,
      descList = _props$descList === void 0 ? ['Note: Maximum file size 5Mb.', 'Suggested image size: 460px x 460px'] : _props$descList,
      iconClassName = props.iconClassName,
      defaultIconClassName = props.defaultIconClassName;

  var _useDropzone = useDropzone({
    maxFiles: 1,
    accept: ['image/jpeg', 'image/png', 'image/jpg'],
    onDrop: function onDrop(acceptedFiles) {
      selectFilesAction(acceptedFiles);
    }
  }),
      open = _useDropzone.open,
      getInputProps = _useDropzone.getInputProps;
  /**
   * methods
   */


  var selectFilesAction = function selectFilesAction(files) {
    chooseFile === null || chooseFile === void 0 ? void 0 : chooseFile(files === null || files === void 0 ? void 0 : files[0]);
  };

  var uploadImageAction = function uploadImageAction() {
    open();
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('relative flex flex-row items-center space-x-5', className),
    children: [loading && /*#__PURE__*/_jsx(LoadingMask, {}), /*#__PURE__*/_jsx(Box, {
      className: clsx('flex h-12 w-12 items-center justify-center overflow-hidden rounded-md bg-[#F3F4F6]', iconClassName),
      children: !!src ? /*#__PURE__*/_jsx("img", {
        src: src,
        alt: "logo",
        className: clsx('aspect-square h-full w-full object-contain', src.includes('base64') ? '' : 'cursor-pointer')
      }) : /*#__PURE__*/_jsx(ImageOutlined, {
        className: clsx('h-6 w-6', defaultIconClassName)
      })
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-1",
      children: [/*#__PURE__*/_jsx("input", _objectSpread({}, getInputProps())), /*#__PURE__*/_jsx(JoveButton, {
        onClick: uploadImageAction,
        disabled: loading || disabled,
        size: "small",
        children: buttonText
      }), descList.map(function (item, index) {
        return /*#__PURE__*/_jsx(Typography, {
          variant: "subtitle2",
          className: "text-xs font-medium italic text-black/70",
          children: item
        }, index);
      })]
    })]
  });
};

export var JoveLogoUploadControlled = function JoveLogoUploadControlled(props) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      containerClassName = props.containerClassName,
      rest = _objectWithoutProperties(props, _excluded);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      value = _useController.field.value,
      error = _useController.fieldState.error;

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveLogoUpload, _objectSpread(_objectSpread({}, rest), {}, {
      src: value,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
};
export default JoveLogoUpload;